import { useMicrocopy } from '@contexts/MicrocopyContext';
import { AtomicContext } from '@contexts/coveo/AtomicContext';
import { MicrocopyFragment } from '@graphql/generated-contentful/graphql';
import { useContext } from 'react';
import { SearchSelect } from './SearchSelect';
import { useResults } from './hooks/useResults';
import { useResultsPerPage } from './hooks/useResultsPerPage';

const RESULTS_PER_PAGE_OPTIONS = [24, 48, 96];

export const ResultsPerPage = ({ context }: { context: AtomicContext }) => {
  const { searchEngine } = useContext(context);
  const { resultsPerPage, setResultsPerPage } = useResultsPerPage(searchEngine);
  const { results: resultState } = useResults(searchEngine);
  const shouldDisplay = resultState?.results && resultState.results.length > 0;
  const { searchLabelsMicrocopy } = useMicrocopy<{
    searchLabelsMicrocopy: MicrocopyFragment[];
  }>();
  const resultsPerPageLabel =
    searchLabelsMicrocopy.find(
      (microcopyFragment) => microcopyFragment.key === 'search.results-per-page'
    )?.value ?? 'Results';

  if (!shouldDisplay) {
    return null;
  }

  return (
    <SearchSelect
      label={resultsPerPageLabel}
      testId="search-results-per-page-select"
      currentValue={resultsPerPage}
      handleChange={(value) => setResultsPerPage(parseInt(value, 10))}
    >
      {RESULTS_PER_PAGE_OPTIONS.map((option) => (
        <option key={option} value={option}>
          {option}
        </option>
      ))}
    </SearchSelect>
  );
};
